import { API_URL } from "api/API";
import getServerTimeApi from "api/common/getServerTimeApi";
import { dateTimeState, serverTimeState } from "libs/atoms";
import { convertDateTime } from "libs/utils";
import { useEffect } from "react";
import { useQuery } from "react-query";
import { useSetRecoilState } from "recoil";

function useRunServerTime() {
  const setServerTime = useSetRecoilState(serverTimeState)
  const { data } = useQuery([API_URL.COMMON.GET_SERVER_TIME], getServerTimeApi, {
    refetchInterval: 1000 * 30,
    refetchIntervalInBackground: true,
    refetchOnWindowFocus: false,
  });

  useEffect(() => {
    if (!data?.date || !data?.time) return;
    const date = new Date(`${data.date.replaceAll('-', '/')} ${data.time}`);

    function updateServerTime(add: 0 | 1) {
      date.setSeconds(date.getSeconds() + add);

      const newDateTime = convertDateTime(date);

      setServerTime({
        obsId: undefined,
        date: newDateTime.date,
        time: newDateTime.time,
      });
    }

    updateServerTime(0);

    const interval = setInterval(() => {
      updateServerTime(1);
    }, 1000);

    return () => clearInterval(interval);
  }, [data, setServerTime]);
}

export default useRunServerTime;